import client from "./client";

export function getFormula (productKey, id) {
    const response = client.get("/api/products/" + productKey + "/formulas/" + id);
    return response;
}

export function getFormulas (productId, params) {
    const response = client.get("/api/products/" + productId + "/formulas", { params: params });
    return response;
}

export function createFormula (productId, params) {
    const response = client.post("/api/products/" + productId + "/formulas", params);
    return response;
}

export function updateFormula (productId, id, params) {
    const response = client.put("/api/products/" + productId + "/formulas/" + id, params);
    return response;
}

export function deleteFormula (productId, id) {
    const response = client.delete("/api/products/" + productId + "/formulas/" + id);
    return response;
}

export function getFormulaCovers (formulaKey, params) {
    const response = client.get(`/api/formulas/${formulaKey}/covers`, { params: params });
    return response;
}